module.exports = __webpack_public_path__ + "img/02.794f9658.jpg";